// Settings
export const GET_SETTINGS_REQUEST = 'GET_SETTINGS_REQUEST';
export const GET_SETTINGS_DONE = 'GET_SETTINGS_DONE';
export const GET_SETTINGS_FAILED = 'GET_SETTINGS_FAILED';